<div>
    <!---------------------------------------- Header ---------------------------------->
    <div class="w-full bg-white/0 mb-2 flex justify-between items-center py-2" style="min-height: 50px;">
        <!-------------------- Head ซ้าย ------------------>
        <div class="w-full flex justify-start items-center space-x-2 px-2">
            <!------------------ สถานะ ------------------>
            <div class="p-2 rounded-lg w-24  flex items-center justify-center" [ngClass]="{ 
                    'bg-yellow-200 dark:bg-yellow-900 bg-opacity-80 text-yellow-700 dark:text-yellow-300': status == 1,
                    'bg-blue-100 dark:bg-blue-900 bg-opacity-80 text-blue-700 dark:text-blue-300': status == 2,
                    'bg-green-200 dark:bg-green-900 bg-opacity-80 text-green-700 dark:text-green-300': status == 3,
                    'bg-red-100 dark:bg-red-900 bg-opacity-80 text-red-700 dark:text-red-300': status == 4,
                }">
                <p>{{
                    status === 1 ? "รออนุมัติ"
                    : status === 2 ? "อนุมัติ"
                    : status === 3 ? "เสร็จสิ้น"
                    : "ยกเลิก"
                    }}</p>
            </div>
            <!------------------ Token ------------------>
            <div *ngIf="token !== ''" class="flex justify-center items-center space-x-2">
                <p class="text-sm text-gray-400 dark:text-gray-300">Token : </p>
                <div class="bg-gray-100 dark:bg-gray-700 p-2 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg flex items-center justify-between"
                    style="width: 250px;">
                    <p class="text-md dark:text-gray-200">{{ token }}</p>
                    <div class="w-4 h-4 cursor-pointer" (click)="onClickCopyCode(token)">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpElEQVR4nO3csWoUURQG4IOKWqgPoJYimE723lEECTaCkjaPYOcaNPes5T6E4otYWFpFsYqBgLi5J0HUykpUNNXKmE52N7PZyZxzZv4f/nJ2Z77cnZk9S4YIQRAEQRCktRnuLZ/lHNZSju84x58scXzcTRL3k8SNgfQK6kIGo+Iy57DVBO5E8Bx+p93iLnVgJW9pIXcGm3NY00buBHYqz8kGkFuPnST+0AGNvzqFzWqrt7h9yB/5D0tcobaElaAP3rtD2KwI3SlsVobuDDYbgO4ENhuBbj02G4JuNTYbg24tNhuENo89a9TpDboM7xR3zH2DPGzU6RHaHHaVUadX6KrYjfx4UGXUaQ2aP12/WCu2xA2yMOo0B53j03mPcxZ2+bMYWRh1WoNOEvdL7DpXdi2YM9+8woEtsi07KaAF0KSNA2jxV0ALoEkbB9Dir4AWQJM2DqDFXwEtgCZtHECLvwJaAE3aOIAWfwW0AJq0cQAt/gpoATRp4wBa/BXQAmjSxgG0+CugBdCkjQNo8VdAC6BJGwfQ4q+AFkCTNk7roPnDrfOWHozCtTd8NwH9ROJVD4/64SM25fDWBPR6Dvcmbbue4yNtpDo6kN5DE9Cc4/NJ2/ZHV86kHN5rQy3UHDaH20unTUAnCZ+Hr5dPTfuv2+QVO4fNxx9vXjp25KrQ/7B344Npr9EvV/ZO7JfnOusXyIP9C2/K00UjK3lu6By/Trv7QCpkvhURXq2OV09q77PLzP3Ry/HZcEwntPfbXY50nsvhZX9UXNDed1dZ4MLyrXwywrS7EeS/LH4lD19YwgvOvfuDvRvXhttL57SPyWS0b7e4xpLlaOMwoP2VLMf6Nzm2NOpcJBh1NhSMOhsKRp0NBqPOBoNRJ4IgCIIgCIIgCLUjfwGnfrd/uiaR+AAAAABJRU5ErkJggg=="
                            alt="copy">
                    </div>
                </div>
            </div>
        </div>
        <!-------------------- Head ขวา ------------------>
        <div class="flex justify-end items-center w-full gap-2">
            <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
                class="p-2 px-4 rounded-lg border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 font-bold hover:border-amber-400 hover:text-amber-600 transition-all inline-flex items-center gap-1.5">
                <span class="material-icons text-[18px]">history</span>
                ดูประวัติ
            </button>
            <!---------------- สร้างรหัส ------------------>
            <button class=" p-2 px-4  bg-green-400 text-white rounded-lg mr-2" (click)="onClickGenerateCode()"
                *ngIf="isDisableInput && status == 2">
                <p>สร้างรหัส</p>
            </button>
            <!---------------- บันทึก ------------------>
            <button class=" p-2 px-4  bg-yellow-400 text-white rounded-lg" (click)="onClickSaveCityparkingStampList()"
                *ngIf="!isDisableInput">
                <p>บันทึก</p>
            </button>
        </div>
    </div>
    <div class="space-y-2 bg-white dark:bg-gray-800 p-4 rounded-lg shadow">
        <!---------------- สถานที่ ------------------>
        <div class="flex justify-center item-center space-x-2 ">
            <div class="flex flex-col justify-center item-center w-full ">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    สถานที่ให้บริการลานจอด
                </label>
                <div class="flex gap-2">
                    <app-input type="text" [valueIn]="siteName" [readOnly]="true"
                        class="flex-1 px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300"></app-input>
                    <button type="button" *ngIf="!isDisableInput" (click)="showSelectProviderModal = true"
                        class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600 whitespace-nowrap rounded-md">
                        เลือก
                    </button>
                </div>
            </div>
        </div>

        <!---------------- ชื่อบัตร + อัตราส่วนลด ------------------>
        <div
            class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full relative">
            <!-- ชื่อบัตรส่วนลด -->
            <div class="w-full md:w-1/2">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    ชื่อแสตมป์ส่วนลด
                </label>
                <app-input [type]="'text'" [valueIn]="name" [validateName]="'name'" [validateType]="'textNumber'"
                    (validateOut)="isValidateTextNumber = $event" [disabled]="isDisableInput" (valueOut)="name = $event"
                    [placeholder]="'กรุณาใส่ชื่อแสตมป์ส่วนลด'" [max]="'30'">
                </app-input>
            </div>
            <!-- ลูกค้า -->
            <div class="w-full md:w-1/2 relative h-16">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    ลูกค้า
                </label>
                <app-select class="absolute w-full " style="z-index: 3;" [valueIn]="selectClient"
                    [option]="optionClient" [disabled]="isDisableInput" (valueOut)="onChangeSelectClient($event)"
                    [placeholder]="'กรุณาเลือกลูกค้า'">
                </app-select>
            </div>

        </div>

        <!---------------- ตราประทับส่วนลด ------------------>
        <div class="w-full relative h-16">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                ตราประทับส่วนลด
            </label>
            <app-select class="absolute w-full" style="z-index: 2;" [valueIn]="selectRate" [option]="rateOptions"
                [disabled]="isDisableInput" (valueOut)="onChangeSelectRate($event)"
                [placeholder]="'กรุณาเลือกตราประทับส่วนลด'">
            </app-select>
        </div>


        <!---------------- ครั้งต่อวัน  + ครั้งต่อเดือน ------------------>
        <div
            class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full relative">
            <!-- ครั้งต่อวัน -->
            <div class="w-full md:w-1/2 relative">
                <!-- Text + Checkbox -->
                <div class="flex item-center space-x-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        กำหนดครั้งต่อวัน |
                    </label>
                    <app-checkbox [valueIn]="stampLimitDay" (checkStatusOut)="onChangeStampLimitDay($event) "
                        *ngIf="!isDisableInput">
                    </app-checkbox>
                </div>
                <!-- Input -->
                <app-input [type]="'number'" [valueIn]="limitDay" [disabled]="isDisableInput || !stampLimitDay"
                    (valueOut)="limitDay = $event" [placeholder]="'กรุณาใส่วันสิ้นสุด'" *ngIf="!isDisableInput">
                </app-input>

            </div>

            <!-- ครั้งต่อเดือน -->
            <div class="w-full md:w-1/2 relative">
                <!-- Text + Checkbox -->
                <div class="flex item-center space-x-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        กำหนดครั้งต่อเดือน |
                    </label>
                    <app-checkbox [valueIn]="stampLimitMonth" (checkStatusOut)="onChangeStampLimitMonth($event) "
                        *ngIf="!isDisableInput">
                    </app-checkbox>
                </div>
                <!-- Input -->
                <app-input [type]="'number'" [valueIn]="limitMonth" [disabled]="isDisableInput || !stampLimitMonth"
                    (valueOut)="limitMonth = $event" [placeholder]="'กรุณาใส่เดือนที่สิ้นสุด'" *ngIf="!isDisableInput">
                </app-input>

            </div>
        </div>


        <!---------------- วันที่เริ่มต้น + สิ้นสุด ------------------>
        <div class="flex justify-center item-center space-x-2">
            <!---------------- วันที่เริ่มต้น ------------------>
            <div class="w-full">
                <div class="flex item-center space-x-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        วันที่เริ่มต้น
                    </label>
                </div>
                <app-input [type]="'date'" [valueIn]="startDate" [disabled]="isDisableInput"
                    (valueOut)="startDate = $event" [placeholder]="'กรุณาเลือกวันที่เริ่มต้น'" *ngIf="!isDisableInput">
                </app-input>
                <!-- แสดงตัวหนังสืออย่างเดียว -->
                <div class="w-full p-2 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-200 dark:bg-gray-700"
                    *ngIf="isDisableInput">
                    <p class="text-gray-400 dark:text-gray-300">{{ startDate | date : "dd/MM/yyyy" }}</p>
                </div>
            </div>
            <!---------------- วันที่สิ้นสุด ------------------>
            <div class="w-full">
                <!-- Text + Checkbox -->
                <div class="flex item-center space-x-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        วันที่สิ้นสุด |
                    </label>
                    <app-checkbox [valueIn]="expireDate" (checkStatusOut)="onChangeStampLimitExpireDate($event) "
                        *ngIf="!isDisableInput">
                    </app-checkbox>
                </div>
                <!-- Input -->
                <app-input [type]="'date'" [valueIn]="endDate" [disabled]="isDisableInput || !expireDate"
                    (valueOut)="endDate = $event" [placeholder]="'กรุณาเลือกวันที่สิ้นสุด'" *ngIf="!isDisableInput">
                </app-input>
                <!-- แสดงตัวหนังสืออย่างเดียว -->
                <div class="w-full p-2 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-200 dark:bg-gray-700"
                    *ngIf="isDisableInput">
                    <p class="text-gray-400 dark:text-gray-300">{{ endDate | date : "dd/MM/yyyy" }}</p>
                </div>
            </div>
        </div>

        <div class="w-full py-1 ">
            <div class="bg-gray-200 dark:bg-gray-700 h-1 rounded-lg"></div>
        </div>
        <!--------------- online ----------------->
        <!---- checkbox --->
        <div class="w-full px-1">
            <app-checkbox [valueIn]="online" [label]="'แสตมป์แบบออนไลน์'" (checkStatusOut)="onChangeOnline($event) "
                *ngIf="!isDisableInput">
            </app-checkbox>
        </div>



        <!----------------- หมายเหตุ ------------------>
        <div class="w-full">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                หมายเหตุ
            </label>
            <textarea class="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200
                       focus:outline-none focus:ring focus:ring-yellow-300
                " placeholder="หมายเหตุ" [(ngModel)]="remark">
            </textarea>
        </div>

    </div>

    <!-------------------------------------------------- ตาราง ---------------------------------->
    <!-- <div class="my-5">
        <div class="flex flex-col w-full bg-white shadow py-2 m-2 rounded-xl">
            <div class="flex item-center gap-2 p-2 " style="min-height: 30px;" >
                <button class="bg-green-400 flex justify-center items-center border border-green-400 px-4 py-2 rounded-md text-sm text-white gap-2"
                    (click)="onExportToExcel()"
                >
                ดาวน์โหลด Excel
                </button>
            </div> 
            <div class="w-full h-0.5 bg-gray-200 my-2" *ngIf="!isDisableInput"></div>
            <div class="w-full overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200 text-sm text-gray-800">
                    <thead class="bg-gray-100 text-gray-700 uppercase text-xs">
                        <tr>
                            <th class="px-4 py-4 text-left">#</th>
                            <th class="px-4 py-4 text-left">ชื่อส่วนลด</th>
                            <th class="px-4 py-4 text-left">รหัสส่วนลด</th>
                            <th class="px-4 py-4 text-center">สถานะ</th>
                            <th class="px-4 py-4 text-left">วันที่สร้าง</th>
                            <th class="px-4 py-4 text-left">วันที่ใช้งาน</th>
                            <th class="px-4 py-4 text-center">สิทธิ์สูงสุด</th>
                            <th class="px-4 py-4 text-center">ใช้งานแล้ว</th>
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-gray-100 bg-white">
                        <tr
                            *ngFor="let c of null; let i = index"
                            class="hover:bg-gray-50 transition cursor-pointer"
                        >
                            <td class="px-4 py-6"  *ngIf="i+1 <= 100">{{ i + 1 }}</td>
                            <td class="px-4 py-6"  *ngIf="i+1 <= 100">{{ c.name }}</td>
                            <td class="px-4 py-4 flex items-center gap-1" *ngIf="i+1 <= 100">
                                <label class="w-40">{{ c.code }}</label>
                                <div class="w-4 h-4 cursor-pointer" 
                                    (click)="onClickCopyCode(c.code)"
                                >
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpElEQVR4nO3csWoUURQG4IOKWqgPoJYimE723lEECTaCkjaPYOcaNPes5T6E4otYWFpFsYqBgLi5J0HUykpUNNXKmE52N7PZyZxzZv4f/nJ2Z77cnZk9S4YIQRAEQRCktRnuLZ/lHNZSju84x58scXzcTRL3k8SNgfQK6kIGo+Iy57DVBO5E8Bx+p93iLnVgJW9pIXcGm3NY00buBHYqz8kGkFuPnST+0AGNvzqFzWqrt7h9yB/5D0tcobaElaAP3rtD2KwI3SlsVobuDDYbgO4ENhuBbj02G4JuNTYbg24tNhuENo89a9TpDboM7xR3zH2DPGzU6RHaHHaVUadX6KrYjfx4UGXUaQ2aP12/WCu2xA2yMOo0B53j03mPcxZ2+bMYWRh1WoNOEvdL7DpXdi2YM9+8woEtsi07KaAF0KSNA2jxV0ALoEkbB9Dir4AWQJM2DqDFXwEtgCZtHECLvwJaAE3aOIAWfwW0AJq0cQAt/gpoATRp4wBa/BXQAmjSxgG0+CugBdCkjQNo8VdAC6BJGwfQ4q+AFkCTNk7roPnDrfOWHozCtTd8NwH9ROJVD4/64SM25fDWBPR6Dvcmbbue4yNtpDo6kN5DE9Cc4/NJ2/ZHV86kHN5rQy3UHDaH20unTUAnCZ+Hr5dPTfuv2+QVO4fNxx9vXjp25KrQ/7B344Npr9EvV/ZO7JfnOusXyIP9C2/K00UjK3lu6By/Trv7QCpkvhURXq2OV09q77PLzP3Ry/HZcEwntPfbXY50nsvhZX9UXNDed1dZ4MLyrXwywrS7EeS/LH4lD19YwgvOvfuDvRvXhttL57SPyWS0b7e4xpLlaOMwoP2VLMf6Nzm2NOpcJBh1NhSMOhsKRp0NBqPOBoNRJ4IgCIIgCIIgCLUjfwGnfrd/uiaR+AAAAABJRU5ErkJggg==" alt="copy">
                                </div>
                            </td>
                            <td class="px-4 py-6 text-center"  *ngIf="i+1 <= 100">
                                <span
                                    [ngClass]="
                                    c.activate
                                        ? 'bg-green-100 text-green-600'
                                        : 'bg-gray-100 text-gray-500'
                                    "
                                    class="px-3 py-2 rounded-lg text-sm font-semibold"
                                >
                                    {{ c.activate ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
                                </span>
                            </td>

                            <td class="px-4 py-6"  *ngIf="i+1 <= 100">{{ c.createDate | date: 'dd/MM/yyyy' }}</td>
                            <td class="px-4 py-6"  *ngIf="i+1 <= 100">{{ c.activateDate | date: 'dd/MM/yyyy' }}</td>
                            <td class="px-4 py-6 text-center"  *ngIf="i+1 <= 100">{{ c.maxUsage }}</td>
                            <td class="px-4 py-6 text-center"  *ngIf="i+1 <= 100">{{ c.usageCount }}</td>

                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div> -->
</div>


<!--------------------------------------------- Modal ------------------------------------->
<!----------- Modal Selected Site ID -------------------->
<app-modal-provider-site [(showModal)]="showSelectProviderModal" [dataList]="allProviders"
    (itemSelected)="selectProvider($event)"></app-modal-provider-site>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && stampListEntityId"
  [entityType]="activityEntityTypes.CityParkingStampList"
  [entityId]="stampListEntityId"
  title="ประวัติ Stamp Discount"
  [subtitle]="'#' + stampListEntityId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>